import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import { CurrencyProvider } from "./currency/CurrencyContext";
import Navbar from "./components/navbar/Navbar";
import Home from "./components/home/Home";
import AboutUs from "./components/aboutus";
import Features from "./components/features";
import SecurityCompliance from "./components/security&compliance";
import PricingAndPlans from "./components/pricing&plans";
import Patners from "./components/patners";
import WaitingList from "./components/waitinglist";
import PrivacyPolicy from "./components/privacy&policy";
import TermsAndConditions from "./components/terms&conditions";
import ContactUs from "./components/contactus";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/ScrollTop";
import PageTitleManager from "./components/common/PageTitleManager";
import Page2026 from "./components/ref2026/Page2026";
import Page2026Pricing from "./components/ref2026/Page2026Pricing";
import Page2026About from "./components/ref2026/Page2026About";
import Page2026Feature from "./components/ref2026/Page2026Feature";
import Page2026Security from "./components/ref2026/Page2026Security";
import Page2026Partners from "./components/ref2026/Page2026Partners";
import Page2026Contact from "./components/ref2026/Page2026Contact";
import Page2026Privacy from "./components/ref2026/Page2026Privacy";
import Page2026Terms from "./components/ref2026/Page2026Terms";
import Page2026WaitingList from "./components/ref2026/Page2026WaitingList";
// Tawk.to chat   re-enable when ready: import TawkToChat from './components/TawkToChat';

// Wrapper component to use useLocation
function AppContent() {
  const location = useLocation();

  // Show legacy navbar/footer only on /2024 routes.
  const hideNavAndFooter = !location.pathname.startsWith("/2024");

  return (
    <>
      <PageTitleManager />
      {!hideNavAndFooter && <Navbar />}
      <ScrollToTop />
      <Routes>
        <Route exact path="/" element={<Page2026 />} />
        <Route path="/pricing" element={<Page2026Pricing />} />
        <Route path="/about" element={<Page2026About />} />
        <Route path="/features" element={<Page2026Feature />} />
        <Route path="/security" element={<Page2026Security />} />
        <Route path="/partners" element={<Page2026Partners />} />
        <Route path="/contact" element={<Page2026Contact />} />
        <Route path="/privacy" element={<Page2026Privacy />} />
        <Route path="/terms" element={<Page2026Terms />} />
        <Route path="/privacy-policy" element={<Page2026Privacy />} />
        <Route path="/terms-conditions" element={<Page2026Terms />} />
        <Route path="/waiting-list" element={<Page2026WaitingList />} />

        <Route exact path="/2024" element={<Home />} />
        <Route exact path="/2024/aboutus" element={<AboutUs />} />
        <Route exact path="/2024/features" element={<Features />} />
        <Route exact path="/2024/security" element={<SecurityCompliance />} />
        <Route exact path="/2024/pricing" element={<PricingAndPlans />} />
        <Route exact path="/2024/patners" element={<Patners />} />
        <Route exact path="/2024/waitinglist" element={<WaitingList />} />
        <Route exact path="/2024/privacy" element={<PrivacyPolicy />} />

        <Route exact path="/2024/terms" element={<TermsAndConditions />} />
        <Route exact path="/2024/contact" element={<ContactUs />} />
      </Routes>
      {!hideNavAndFooter && <Footer />}
      {/* Tawk.to chat   uncomment when bringing back: <TawkToChat /> */}
    </>
  );
}

function App() {
  return (
    <CurrencyProvider>
      <Router>
        <AppContent />
      </Router>
    </CurrencyProvider>
  );
}

export default App;
